/* eslint-disable jsx-a11y/alt-text */
import CaptureWarning from "./CaptureWarning";
import React, { useEffect, useState } from "react";
import { VscChromeClose } from "react-icons/vsc";
import ReactModal from "react-modal";
import http, { downloadUrl, URL_S3 } from "../../../config/BaseUrl";
import PhotoGalleryDetails from "./PhotoGalleryDetails";

ReactModal.setAppElement("#root");

const PhotoGallery = (prop) => {
  // MOdal
  const [modalIsOpen, setIsOpen] = useState(false);

  const downloadImage = (id, file_name) => {
    window.open(`${downloadUrl}social-gallery-download/${id}`);

    // baseURLPublic.get(`social-gallery-download/${id}`, {
    //   responseType: 'blob'
    // }).then((res) => {
    //   fileDownload(res.data, file_name);
    // })
  };

  const deleteImage = (id) => {
    if (window.confirm('Are you sure you want to delete this image?')) {
      http.post(`gallery-item-delete/${id}`).then((res) => {
        if (res.data.status === "success") {
          window.location.reload();
        }
      }).catch((err) => {
        console.error('Error deleting image:', err);
        alert('Failed to delete image');
      });
    }
  };

  const { photo } = prop;

  const [photoDetails, setPhotoDetails] = useState({});
  const [activeItem, setActiveItem] = useState(null);

  const previewImageDetails = async (id, photo_url, indexItem) => {
    setActiveItem(indexItem);
    await http.get(`media/item-details?media_id=${id}`).then((res) => {
      if (res.data.status === "success") {
        setPhotoDetails({ media: res.data.media, photo_url });
      }
    });
    setIsOpen(true);
  };

  useEffect(() => {
    
  },[photoDetails])
   
  return (
    <>
      <div className="pt-2 photos">
        <div className="row">
          <div className="col-12">
            <div className="analytic-photos">
              <div className="mt-3 gallery-body">
                <div className="row">
                  <div className="col-12">
                    <h5 className="text-secondary">Photo</h5>
                  </div>
                  <div className="col-12">
                    <div className="photos-list">
                      <div className="row gallery-horizontal">
                        {photo && photo.length > 0 ? (
                          photo.map((item, index) => {
                            return (
                              <div
                                key={item.id}
                                className="mb-4 text-center gallery-item col-md-3"
                                style={{ position: "relative" }}
                              >
                                <div style={{ position: "absolute", top: "5px", right: "5px", zIndex: 10, display: "flex", gap: "5px" }}>
                                  <CaptureWarning media={item} />
                                  <span
                                    className="download-single-button"
                                    onClick={downloadImage.bind(
                                      this,
                                      item.id,
                                      item.event_photo
                                    )}
                                    style={{
                                      position: "relative",
                                      top: "auto",
                                      right: "auto",
                                      background: "rgba(0,0,0,0.75)",
                                      border: "1px solid rgba(255,255,255,0.3)"
                                    }}
                                  >
                                    <i className="lni lni-download"></i>
                                  </span>
                                  <span
                                    className="download-single-button"
                                    onClick={deleteImage.bind(
                                      this,
                                      item.id
                                    )}
                                    style={{
                                      position: "relative",
                                      top: "auto",
                                      right: "auto",
                                      color: "#ff4444",
                                      background: "rgba(0,0,0,0.75)",
                                      border: "1px solid rgba(255,255,255,0.3)"
                                    }}
                                  >
                                    <i className="lni lni-trash"></i>
                                  </span>
                                </div>
                                <div className="image">
                                  <img
                                    src={`${URL_S3}event_gallery/photo/${item.event_photo}`}
                                    alt="placeholder"
                                    className="cursor-pointer hello img-fluid"
                                    onClick={previewImageDetails.bind(
                                      this,
                                      item.id,
                                      item.event_photo,
                                      index
                                    )}
                                  />
                                </div>
                              </div>
                            );
                          })
                        ) : (
                          <div className="my-5 text-center col-md-12">
                            <b>Items Not Available</b>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={() => setIsOpen(false)}
        className="gallery-preview-modal"
        overlayClassName="gallery-preview-overlay"
        contentLabel="Photo preview"
      >
        <div className="fullscreen_view_area">
          <button type="button" className="close_icon" onClick={() => setIsOpen(false)} aria-label="Close photo preview">
            <VscChromeClose size="20" />
          </button>
          <div className="closeIconArea">
            <PhotoGalleryDetails 
            photoShareDetails={photoDetails}
            dataSlider={photo}
            activeItemIndex={activeItem}
            />
          </div>
        </div>
      </ReactModal>
    </>
  );
};

export default PhotoGallery;
